export enum TipoCapacidad {
	Tecnica = 1,
  Operativa = 2
}
